const zhCNDictionary = {
    'header.title': 'OceanMind海眠-在线思维导图编辑器',
    'toolbar.newCanvas': '新建画布',
    'header.toolbarReset': '恢复工具栏',
    'header.toolbarReset.tooltip': '重置中央工具栏位置',
    'header.emergencySave': '紧急保存',
    'header.emergencySave.tooltip': '提供保存与导出操作，避免工具栏丢失',
    'toolbar.dragHandle': '拖动工具栏',
    'header.theme.tooltip': '切换主题色',
    'header.theme': '主题色',
    'header.darkmode.tooltip': '切换暗黑/明亮模式',
    'header.contact': '联系我',
    'header.home': '我的主页',
    'header.language': '语言',
    'header.language.zh': '中文',
    'header.language.en': 'English',
    'auth.entry': '登录/注册',
    'auth.login.tab': '登录',
    'auth.register.tab': '注册',
    'auth.logout': '退出登录',
    'auth.modal.title': '登录 OceanMind',
    'auth.field.name': '昵称',
    'auth.field.email': '邮箱',
    'auth.field.password': '密码',
    'auth.field.confirmPassword': '确认密码',
    'auth.placeholder.name': '请输入昵称',
    'auth.placeholder.email': '请输入邮箱',
    'auth.placeholder.password': '请输入密码',
    'auth.placeholder.confirmPassword': '请再次输入密码',
    'auth.action.login': '登录',
    'auth.action.register': '注册并登录',
    'auth.helper': '登录后可启用云端项目与同步',
    'auth.warning.title': '登录/注册功能测试提示',
    'auth.warning.message': '登录/注册功能当前处于测试阶段，建议将项目文件保存到本地并做好备份，云端依赖可能存在数据丢失风险。',
    'auth.warning.checkbox': '不再提醒',
    'auth.warning.confirm': '继续登录/注册',
    'auth.warning.cancel': '暂不登录',
    'auth.warning.banner': '登录/云端功能正在测试中，请务必本地备份，云端可能存在数据丢失风险。',
    'auth.validation.email': '请输入有效的邮箱',
    'auth.validation.name': '请输入昵称',
    'auth.validation.password': '请输入密码',
    'auth.validation.password.length': '\u5bc6\u7801\u957f\u5ea6\u9700\u4e3a 8-128 \u4e2a\u5b57\u7b26',
    'auth.validation.confirmPassword': '请确认密码',
    'auth.validation.confirmPassword.mismatch': '两次输入的密码不一致',
    'auth.validation.turnstile': '请完成人机验证',
    'auth.validation.turnstile.missing': 'Turnstile 未配置',
    'auth.error.generic': '登录失败，请稍后重试',
    'auth.session.expired': '登录已过期，请重新登录',
    'auth.session.signedIn': '已登录',
    'share.brand': 'OceanMind 分享',
    'share.badge.readonly': '只读分享',
    'share.badge.offline': '\u79bb\u7ebf',
    'share.action.save': '保存副本',
    'share.action.loginSave': '登录后保存',
    'share.action.back': '返回编辑器',
    'share.title.fallback': '共享思维导图',
    'share.load.loading': '正在加载分享内容...',
    'share.load.failed': '分享内容加载失败',
    'share.load.invalid': '\u5206\u4eab\u5185\u5bb9\u683c\u5f0f\u5f02\u5e38\uff0c\u65e0\u6cd5\u663e\u793a',
    'share.load.repaired': '\u5df2\u81ea\u52a8\u4fee\u590d {count} \u9879\u5206\u4eab\u6570\u636e\u95ee\u9898\uff0c\u73b0\u53ef\u5b89\u5168\u6d4f\u89c8',
    'share.load.notFound': '分享已失效或不存在',
    'share.load.timeout': '加载分享内容超时，请检查网络后重试',
    'share.load.retry': '重试加载',
    'share.load.offline': '\u5f53\u524d\u79bb\u7ebf\uff0c\u8bf7\u8fde\u63a5\u7f51\u7edc\u540e\u91cd\u8bd5',
    'share.load.waitingOnline': '\u7b49\u5f85\u7f51\u7edc\u6062\u590d...',
    'share.save.success': '已保存到我的空间',
    'share.save.success.named': '已保存到我的空间：{name}',
    'share.save.failed': '保存副本失败',
    'share.save.timeout': '\u4fdd\u5b58\u526f\u672c\u8d85\u65f6\uff0c\u8bf7\u68c0\u67e5\u7f51\u7edc\u540e\u91cd\u8bd5',
    'share.save.offline': '\u5f53\u524d\u79bb\u7ebf\uff0c\u65e0\u6cd5\u4fdd\u5b58\u526f\u672c',
    'share.create.login': '登录后可创建分享链接',
    'share.create.select': '请选择要分享的文件',
    'share.create.failed': '创建分享链接失败',
    'share.create.timeout': '\u521b\u5efa\u5206\u4eab\u94fe\u63a5\u8d85\u65f6\uff0c\u8bf7\u68c0\u67e5\u7f51\u7edc\u540e\u91cd\u8bd5',
    'share.create.title': '分享链接',
    'share.create.desc': '复制链接后即可分享给他人只读查看。',
    'share.create.copy': '复制链接',
    'share.create.copied': '分享链接已复制',
    'share.create.copyFailed': '复制失败，请手动复制链接',
    'workspace.tab': '文件',
    'workspace.title': '本地文件',
    'workspace.title.cloud': '云端文件',
    'workspace.newFile': '新建导图',
    'workspace.newFolder': '新建文件夹',
    'workspace.rename': '重命名',
    'workspace.delete': '删除',
    'workspace.empty': '暂无文件',
    'workspace.search.placeholder': '\u641c\u7d22\u6587\u4ef6\u6216\u6587\u4ef6\u5939',
    'workspace.search.empty': '\u672a\u627e\u5230\u5339\u914d\u9879',
    'workspace.error.load': '\u4e91\u7aef\u6587\u4ef6\u52a0\u8f7d\u5931\u8d25',
    'workspace.error.loadTimeout': '\u4e91\u7aef\u6587\u4ef6\u52a0\u8f7d\u8d85\u65f6\uff0c\u8bf7\u68c0\u67e5\u7f51\u7edc\u540e\u91cd\u8bd5',
    'workspace.error.open': '\u6587\u4ef6\u52a0\u8f7d\u5931\u8d25',
    'workspace.error.openTimeout': '\u6587\u4ef6\u52a0\u8f7d\u8d85\u65f6\uff0c\u8bf7\u68c0\u67e5\u7f51\u7edc\u540e\u91cd\u8bd5',
    'workspace.error.action': '\u64cd\u4f5c\u5931\u8d25\uff0c\u8bf7\u91cd\u8bd5',
    'workspace.error.actionTimeout': '\u64cd\u4f5c\u8d85\u65f6\uff0c\u8bf7\u68c0\u67e5\u7f51\u7edc\u540e\u91cd\u8bd5',
    'workspace.error.saveBeforeSwitch': '当前文件保存失败，已取消切换以避免数据丢失，请先重试保存',
    'workspace.error.deleteRootFolder': '默认根文件夹不能删除',
    'sync.status.idle': '已同步',
    'sync.status.dirty': '未保存',
    'sync.status.syncing': '同步中',
    'sync.status.error': '同步失败',
    'sync.status.storageFull': '\u5B58\u50A8\u7A7A\u95F4\u4E0D\u8DB3',
    'sync.status.storageUnavailable': '\u5B58\u50A8\u4E0D\u53EF\u7528',
    'sync.status.conflict': '存在冲突',
    'sync.status.local': '本地存储',
    'sync.action.retry': '重试',
    'sync.file.untitled': '未命名文件',
    'sync.conflict.title': '检测到同步冲突',
    'sync.conflict.description': '云端版本已更新，请选择如何处理当前更改。',
    'sync.conflict.action.keep': '保留云端版本',
    'sync.conflict.action.overwrite': '覆盖云端',
    'sync.conflict.action.copy': '另存为副本',
    'sync.conflict.copySuffix': '（副本）',
    'sync.conflict.error': '处理冲突失败，请重试',
    'sync.switch.title.dirty': '未保存更改',
    'sync.switch.title.error': '同步失败',
    'sync.switch.content.dirty': '当前文件有未保存的修改，切换前请选择处理方式。',
    'sync.switch.content.error': '当前文件保存失败，是否重试后切换？',
    'sync.switch.action.save': '保存并切换',
    'sync.switch.action.copy': '另存为副本',
    'sync.switch.action.discard': '放弃并切换',
    'sync.switch.action.retry': '重试并切换',
    'sync.switch.blocked.conflict': '存在冲突，请先处理冲突。',
    'sync.switch.blocked.syncing': '正在同步，请稍候再切换。',
    'focus.mode.exit': '退出孤立模式',
    'focus.mode.title': '孤立模式：{title}',
    'focus.mode.tag': '孤立模式',
    'focus.mode.notice': '当前仅显示该节点及其子节点',
    'focus.mode.untitled': '未命名节点',
    'workspace.modal.newFile': '新建导图',
    'workspace.modal.newFolder': '新建文件夹',
    'workspace.modal.rename': '重命名',
    'workspace.field.name': '名称',
    'workspace.action.create': '创建',
    'workspace.action.save': '保存',
    'workspace.action.cancel': '取消',
    'workspace.confirm.delete': '确定删除该项及其子项？',

    'theme.blue': '蓝色',
    'theme.green': '绿色',
    'theme.purple': '紫色',
    'theme.orange': '橙色',

    'palette.business-classic.name': '商务经典',
    'palette.elegant-grace.name': '优雅格调',
    'palette.vibrant-energy.name': '悦动活力',
    'palette.youthful-spring.name': '青春飞扬',
    'palette.tech-future.name': '科技未来',
    'palette.romantic-purple.name': '浪漫丁香',
    'palette.ocean-blue.name': '海洋之谜',
    'palette.forest-green.name': '森林物语',
    'palette.sunset-glow.name': '落日余晖',
    'palette.minimalist-gray.name': '简约灰度',

    'sidebar.palette.tab': '色卡',
    'sidebar.palette.title': '思维导图色卡',
    'sidebar.structure.tab': '结构',
    'sidebar.structure.title': '思维导图结构',
    'sidebar.structure.globalTitle': '全图默认结构',
    'sidebar.structure.globalHint': '仅作用于未设置局部覆盖的分支。节点级子布局请在节点样式面板中设置。',
    'sidebar.structure.currentProfile': '\u5f53\u524d\u5168\u56fe\u7ed3\u6784\uff1a{structure}',
    'sidebar.structure.branchScopeSummary': '全图默认会影响 {inheriting} 个继承分支；{overrides} 个分支保持局部覆盖。',
    'sidebar.structure.overrideBreakdown': '\u5c40\u90e8\u8986\u76d6\u6309\u7ed3\u6784\u7edf\u8ba1\uff1a',

    'sidebar.structure.clearLocalOverridesBtn': '清除局部覆盖（{count}）',
    'sidebar.structure.clearOverridesConfirmTitle': '清除所有局部分支覆盖？',
    'sidebar.structure.clearOverridesConfirmBody': '这将把 {count} 个局部分支覆盖重置为继承全图默认结构。',
    'sidebar.structure.clearOverridesDone': '已清除 {count} 个局部分支覆盖。',
    'sidebar.structure.clearOverridesNothing': '当前没有可清除的局部分支覆盖。',
    'sidebar.structure.globalFreeModePending': '已更新全图结构。切回自动布局模式后会执行分支重排。',
    'sidebar.structure.globalSwitchDone': '已将全图默认结构切换为 {structure}。',
    'layout.structure.mindMap': '思维导图（Mind Map）',
    'layout.structure.logicChart': '逻辑图（Logic Chart）',
    'layout.structure.braceMap': '大括号图（Brace Map）',
    'layout.structure.orgChart': '组织图（Org Chart）',
    'layout.structure.treeChart': '树状图（Tree Chart）',
    'layout.structure.timeline': '时间轴（Timeline）',
    'layout.structure.fishbone': '鱼骨图（Fishbone）',
    'layout.structure.hint.mindMap': '经典横向主题分支',
    'layout.structure.hint.logicChart': '线性推演逻辑路径',
    'layout.structure.hint.braceMap': '大括号分组连线表达',
    'layout.structure.hint.orgChart': '自上而下的层级通道',
    'layout.structure.hint.treeChart': '垂直树形延展结构',
    'layout.structure.hint.timeline': '时间线排列展示顺序',
    'layout.structure.hint.fishbone': '因果分析鱼骨结构',
    'localLayout.emptySelection': '未选中节点',
    'localLayout.title': '子布局结构',
    'localLayout.titleTooltip': '设置该节点的直接子节点分支簇如何排布。',
    'localLayout.modeLabel': '当前模式',
    'localLayout.inheritTag': '继承',
    'localLayout.overrideTag': '覆盖',
    'localLayout.inheritedFromParent': '继承自父节点：{structure}',
    'localLayout.rootInheritHint': '根节点继承全图默认分支结构',
    'localLayout.sourceLocalOverride': '使用当前节点覆盖',
    'localLayout.sourceGlobalDefault': '继承自全图默认结构',
    'localLayout.sourceParent': '继承自父节点分支：{structure}',
    'localLayout.sourceAncestor': '继承自祖先分支：{structure}',
    'localLayout.sourceParentNode': '继承自父节点“{node}”：{structure}',
    'localLayout.sourceAncestorNode': '继承自祖先节点“{node}”：{structure}',
    'localLayout.selectLabel': '选择子布局结构：',
    'localLayout.selectPlaceholder': '请选择子布局结构',
    'localLayout.p0Group': 'P0 结构',
    'localLayout.restoreInheritance': '恢复继承',
    'localLayout.setGlobalDefault': '设为全图默认',
    'localLayout.setGlobalDefaultRoot': '应用到整张图',
    'localLayout.globalAlreadyDefault': '该结构已经是全图默认结构。',
    'localLayout.globalStructureInherited': '\u5f53\u524d\u7ed3\u6784\u4e0e\u5168\u56fe\u9ed8\u8ba4\u4e00\u81f4\uff1a{structure}\u3002',
    'localLayout.globalStructureMatchesOverride': '\u5f53\u524d\u7ed3\u6784\u4e0e\u5168\u56fe\u9ed8\u8ba4\uff08{structure}\uff09\u4e00\u81f4\uff1b\u53ef\u70b9\u51fb\u201c\u6062\u590d\u7ee7\u627f\u201d\u6e05\u9664\u5c40\u90e8\u8986\u76d6\u3002',
    'localLayout.globalStructureDifferent': '\u5168\u56fe\u9ed8\u8ba4\u7ed3\u6784\u4e3a {structure}\uff0c\u5f53\u524d\u5206\u652f\u4f7f\u7528\u4e86\u4e0d\u540c\u7ed3\u6784\u3002',
    'localLayout.globalAlreadyDefaultUseRestore': '\u5f53\u524d\u5df2\u4e0e\u5168\u56fe\u9ed8\u8ba4\u4e00\u81f4\uff0c\u53ef\u70b9\u51fb\u201c\u6062\u590d\u7ee7\u627f\u201d\u6e05\u9664\u5c40\u90e8\u8986\u76d6\u3002',
    'localLayout.reflowBranch': '\u91cd\u6392\u5f53\u524d\u5206\u652f',
    'localLayout.reflowWholeMap': '\u91cd\u6392\u6574\u5f20\u56fe',
    'localLayout.reflowBranchWithCount': '\u91cd\u6392\u5f53\u524d\u5206\u652f\uff08{count} \u4e2a\u540e\u4ee3\u8282\u70b9\uff09',
    'localLayout.reflowWholeMapWithCount': '\u91cd\u6392\u6574\u5f20\u56fe\uff08{count} \u4e2a\u540e\u4ee3\u8282\u70b9\uff09',
    'localLayout.reflowBranchAutoOnly': '\u91cd\u6392\uff08\u81ea\u52a8\u6a21\u5f0f\uff09',
    'localLayout.reflowBranchAutoOnlyHint': '\u8bf7\u5148\u5207\u56de\u81ea\u52a8\u5e03\u5c40\u6a21\u5f0f\uff0c\u518d\u6267\u884c\u5f53\u524d\u5206\u652f\u91cd\u6392\u3002',
    'localLayout.branchReflowDone': '\u5df2\u91cd\u6392\u5f53\u524d\u5206\u652f\uff08{direct} \u4e2a\u76f4\u63a5\u5b50\u8282\u70b9\uff0c{descendants} \u4e2a\u540e\u4ee3\u8282\u70b9\uff0c\u5171 {total} \u4e2a\u8282\u70b9\uff09\u3002',
    'localLayout.branchReflowQueued': '\u5f53\u524d\u5206\u652f\u91cd\u6392\u5df2\u5165\u961f\uff08{direct} \u4e2a\u76f4\u63a5\u5b50\u8282\u70b9\uff0c{descendants} \u4e2a\u540e\u4ee3\u8282\u70b9\uff0c\u5171 {total} \u4e2a\u8282\u70b9\uff09\u3002',
    'localLayout.rootReflowDone': '\u5df2\u91cd\u6392\u6574\u5f20\u56fe\uff08{direct} \u4e2a\u76f4\u63a5\u5b50\u8282\u70b9\uff0c{descendants} \u4e2a\u540e\u4ee3\u8282\u70b9\uff0c\u5171 {total} \u4e2a\u8282\u70b9\uff09\u3002',
    'localLayout.rootReflowQueued': '\u6574\u56fe\u91cd\u6392\u5df2\u5165\u961f\uff08{direct} \u4e2a\u76f4\u63a5\u5b50\u8282\u70b9\uff0c{descendants} \u4e2a\u540e\u4ee3\u8282\u70b9\uff0c\u5171 {total} \u4e2a\u8282\u70b9\uff09\u3002',
    'localLayout.branchReflowNoChildren': '\u5f53\u524d\u5206\u652f\u6ca1\u6709\u53ef\u91cd\u6392\u7684\u5b50\u8282\u70b9\u3002',
    'localLayout.branchReflowNoChanges': '\u5f53\u524d\u5206\u652f\u5df2\u4e0e\u9009\u4e2d\u7ed3\u6784\u4fdd\u6301\u4e00\u81f4\u3002',
    'localLayout.overrideApplied': '\u5df2\u5c06 {structure} \u5e94\u7528\u5230\u5f53\u524d\u5206\u652f\u3002',
    'localLayout.overrideAppliedNoChanges': '\u5f53\u524d\u5206\u652f\u5df2\u4f7f\u7528 {structure}\uff0c\u65e0\u9700\u66f4\u6539\u3002',
    'localLayout.overrideQueued': '\u5df2\u4e3a\u5f53\u524d\u5206\u652f\u4fdd\u5b58 {structure}\uff0c\u6b63\u5728\u6392\u961f\u91cd\u6392\u3002',
    'localLayout.inheritanceRestored': '\u5df2\u6062\u590d\u7ee7\u627f {structure}\u3002',
    'localLayout.inheritanceRestoredNoChanges': '\u5f53\u524d\u5206\u652f\u5df2\u7ee7\u627f {structure}\uff0c\u65e0\u9700\u66f4\u6539\u3002',
    'localLayout.inheritanceRestoreQueued': '\u5df2\u6062\u590d\u7ee7\u627f {structure}\uff0c\u6b63\u5728\u6392\u961f\u91cd\u6392\u3002',
    'localLayout.tip': '提示：该设置仅影响当前节点的直接子分支簇，不会改变父子级核心数据模型。',
    'localLayout.scopeHint': '\u672c\u5206\u652f\u5f71\u54cd {direct} \u4e2a\u76f4\u63a5\u5b50\u8282\u70b9\u3001{descendants} \u4e2a\u540e\u4ee3\u8282\u70b9\uff08\u542b\u5f53\u524d\u5206\u652f\u6839\u8282\u70b9\u5171 {total} \u4e2a\u8282\u70b9\uff09\u3002',
    'localLayout.rootSelectionHint': '在根节点上选择结构时，会同步更新整图默认分支结构。',
    'localLayout.freeModeHint': '自由布局模式下仅保存该设置；切回自动布局模式后才会执行完整分支重排。',
    'localLayout.freeModePendingApply': '已在自由布局模式下保存设置。切回自动布局后将执行分支重排。',
    'layout.horizontal': '水平布局',
    'layout.vertical': '垂直布局',
    'layout.radial': '辐射布局',
    'layout.fishbone': '鱼骨图布局',
    'layout.orgchart': '组织结构图',
    'sidebar.edge.type': '连接线类型',
    'edge.straight': '直线',
    'edge.smooth': '圆角直线',
    'edge.step': '阶梯线',
    'edge.simple': '笔直线',
    'sidebar.style.tab': '样式',
    'sidebar.node.shape': '节点形状',
    'shape.roundedRect': '圆角矩形',
    'shape.capsule': '胶囊形',
    'shape.circle': '圆形',
    'shape.rect': '矩形',
    'shape.diamond': '菱形',
    'shape.hexagon': '六边形',
    'shape.octagon': '八边形',
    'shape.parallelogram': '平行四边形',
    'shape.cloud': '云形',
    'shape.document': '文档形',
    'shape.cylinder': '圆柱形',
    'shape.foldedCorner': '折叠角',
    'shape.star': '五角星',
    'shape.tag': '标签形',
    'style.withBorder': '带边框',
    'style.shadow': '阴影效果',
    'style.gradient': '渐变背景',
    'style.dashed': '虚线边框',
    'sidebar.node.library': '节点库',

    'toolbar.export': '导出',
    'toolbar.exporting': 'Exporting...',
    'toolbar.import': '导入',
    'toolbar.addChild': '添加子节点',
    'toolbar.insertImage': '插入图片',
    'toolbar.deleteNode': '删除节点',
    'node.delete.confirm': '再次点击确认删除',
    'toolbar.isolate': '孤立模式',
    'toolbar.editNode': '编辑节点',
    'toolbar.undo': '撤销',
    'toolbar.redo': '重做',
    'toolbar.zoomIn': '放大',
    'toolbar.zoomOut': '缩小',
    'toolbar.fitView': '适配视图',
    'toolbar.fullscreen': '全屏切换',
    'toolbar.changeLayout': '更改布局',
    'toolbar.edgeStyle': '连接线样式',
    'toolbar.toggleStylePanel.show': '显示样式面板',
    'toolbar.toggleStylePanel.hide': '隐藏样式面板',
    'toolbar.toggleLeftSidebar.show': '显示左侧面板',
    'toolbar.toggleLeftSidebar.hide': '隐藏左侧面板',
    'sidebar.left.label': '左侧面板',
    'sidebar.right.label': '右侧面板',
    'editor.minimap.label': '鸟瞰图',
    'editor.minimap.show': '显示鸟瞰图',
    'editor.minimap.hide': '隐藏鸟瞰图',
    'toolbar.copy': '复制节点',
    'toolbar.cut': '剪切节点',
    'toolbar.paste': '粘贴节点',
    'toolbar.save': '保存',
    'toolbar.onboarding': 'Quick Start',

    'export.menu.project': '导出项目文件(.mmapx)',
    'export.menu.png': '导出为PNG',
    'export.menu.jpg': '导出为JPG',
    'export.menu.svg': '导出为SVG',
    'export.menu.pdf': '导出为PDF',
    'export.menu.pdf.simplifiedSvg': '方法1（矢量，推荐；视觉可能与画布略有差异）',
    'export.menu.pdf.png': '方法2（位图高保真，文件较大但更接近所见即所得）',
    'export.menu.pdf.canvas': '方法3（位图兼容模式，文件较大）',
    'export.menu.pdf.svg': '方法4（DOM SVG，实验性）',
    'export.menu.json': '导出为JSON',
    'export.menu.xmind': '导出为XMind',
    'import.menu.project': '导入项目文件(.mmapx)',
    'import.menu.json': '从JSON导入',
    'import.menu.xmind': '从XMind导入',
    'import.menu.text': '从文本导入',

    'welcome.title': '欢迎使用 OceanMind',
    'welcome.version': '版本',
    'welcome.start': '开始创作',
    'welcome.viewHome': '查看我的主页',
    'welcome.noShowAgain': '不再显示此欢迎界面',
    'welcome.slogan1': '🌊 OceanMind 2.0 全面升级，视觉、布局与导出体验一起刷新',
    'welcome.slogan2': '这次也加入了全新的介绍页，希望大家喜欢。',
    'welcome.highlights': '新功能亮点',
    'welcome.features': '软件特色功能',
    'welcome.thanks': '希望大家喜欢这次 2.0 更新。如果发现任何 BUG，欢迎通过右上角 B站入口反馈。',
    'welcome.feature.v2VisualRefresh': '🎨 整体视觉效果全面升级，编辑器与页面更现代、更统一。',
    'welcome.feature.v2LandingPage': '🏠 新增介绍页，第一次访问时可以先快速了解 OceanMind。',
    'welcome.feature.v2LayoutSystem': '🧭 布局系统大幅升级，鱼骨图重做为真正的 Ishikawa 分析图，并增强布局回归验证。',
    'welcome.feature.v2ExportPolish': '📄 PDF 导出继续打磨，中文矢量 PDF 与兼容模式都更稳定。',
    'welcome.feature.v2Feedback': '📣 如果遇到 BUG，请从右上角进入 B站主页反馈。',
    'welcome.feature.panelBorderStyle': '🎨 右下角面板可以编辑节点边框样式了！',
    'welcome.feature.ui': '🎨 全新的思维导图编辑器界面',
    'welcome.feature.nodeShapes': '🔧 支持多种节点形状和样式',
    'welcome.feature.smartLayout': '📊 智能布局算法（水平、垂直、径向、鱼骨图）',
    'welcome.feature.dragCreate': '🎯 拖拽式节点创建',
    'welcome.feature.exportFormats': '💾 支持多种导出格式（PNG、JPG、SVG、PDF、JSON）',
    'welcome.feature.themes': '🌈 丰富的颜色主题和调色板',
    'welcome.feature.collaboration': '⚡ 实时协作编辑功能',
    'welcome.feature.zoomPan': '🔍 缩放和平移操作',
    'welcome.feature.toolbarOptimize': '🛠️ 中央工具栏优化：缩减宽度避免遮挡，并支持拖拽调整宽度',
    'welcome.feature.autoSaveProtect': '🛡️ 自动保存优化：版本更新推送后不再覆盖本地已有存储，提供恢复选项',
    'welcome.feature.versionDisplay': '🔖 顶部页眉新增版本号显示',
    'welcome.feature.layoutUpgrade': '🧭 全面升级布局系统：工具栏新增“布局”入口，支持双向树形图；自动布局下可拖动调整节点位置。',
    'welcome.feature.textDraftMode': '📝 全新文本草稿模式：工具栏左侧可切换文本视图，问号查看格式，通过缩进快速生成思维导图（小贴士：可将格式要求交给 AI 帮你生成）。',
    'welcome.feature.workspaceModes': '📂 左侧新增文件管理系统，支持本地/云端双模式。',
    'welcome.feature.cloudAuthPreview': '☁️ 云端用户系统抢先体验：登录即可同步文件。系统仍在完善中，请务必备份重要项目。',

    'welcome.feature.responsive': '📱 响应式设计，完美适配移动端',
    'welcome.feature.newUI': '🎨 全面重构面板界面视觉效果，采用更为现代的亚克力风格',
    'welcome.feature.hidePanels': '👁️ 左右面板现可隐藏，避免占用页面内容',
    'welcome.feature.toolbarFix': '🔧 中央工具栏消失BUG修复，现在会始终显示在最前端',
    'welcome.feature.newPalettes': '🌈 全面重做色板预设，一键快速应用主题，提供更好的视觉效果',
    'welcome.feature.nodeOverlapFix': '📏 修复节点过高、过长时遮挡其他节点的问题',
    'welcome.feature.autoLayoutEdit': '⌨️ 自动布局模式优化：空格编辑节点，Tab/Enter不退出节点',
    'welcome.feature.bilingual': '🌐 增加了中英文双语支持',

    'editor.hints.shortcuts': '键盘快捷键',
    'editor.hints.editTextSpace': '按Space键：编辑节点文本',
    'editor.hints.editTextF2': '按F2键：编辑节点文本',
    'editor.hints.editTextDblClick': '双击节点：编辑节点文本',
    'editor.hints.copyCutPaste': 'Ctrl/Cmd + C/X/V：复制/剪切/粘贴节点',
    'editor.hints.deleteNode': 'Delete/Backspace：删除节点',
    'editor.hints.undoRedo': 'Ctrl/Cmd + Z/Y：撤销/重做',
    'editor.hints.save': 'Ctrl/Cmd + S\uFF1A\u4FDD\u5B58\u5F53\u524D\u5BFC\u56FE',
    'editor.hints.zoom': 'Ctrl/Cmd + +/-/0：缩放画布/适配视图',
    'editor.hints.addChild': '按Tab键：添加子节点',
    'editor.hints.addSibling': '按Enter键：添加同级节点',
    'editor.hints.dragRelation': '拖拽节点：调整节点父子关系',
    'editor.hints.structureStyle': '结构样式',
    'editor.mode.auto': '已切换到自动布局模式',
    'editor.mode.free': '已切换到自由布局模式',
    'editor.mode.auto.detail': '已切换到自动布局模式，使用Tab键添加子节点，Enter键添加同级节点',
    'editor.mode.free.detail': '已切换到自由布局模式，您可以自由拖动节点',
    'editor.hints.autoLayoutTip': '自动布局模式下：按Tab键添加子节点，按Enter键添加同级节点，拖拽节点可调整父子关系',
    'editor.import.title': '导入思维导图',
    'editor.import.text.label': '文本导入',
    'editor.import.file.label': '文件导入',
    'editor.view.canvas': '画布',
    'editor.view.text': '文本',
    'editor.textDraft.title': '文本草稿',
    'editor.textDraft.placeholder': '在此整理文本大纲，切换画布不会丢失草稿',
    'editor.textDraft.sidePanelTitle': '文本模式面板',
    'editor.textDraft.sidePanelBody': '右侧保留了文本模式的快捷操作与解析状态，中央面板负责完整的大纲编辑。',
    'editor.textDraft.sidePanelStatus': '当前状态',
    'editor.textDraft.sidePanelFootnote': '切回画布视图后，可继续编辑节点样式、结构和色卡。',
    'editor.textDraft.helpTitle': '基本语法',
    'editor.textDraft.helpIntro': '每行一个节点，缩进表示层级。',
    'editor.textDraft.helpBullet.indent': '推荐使用 2 个空格或 Tab 作为一级缩进',
    'editor.textDraft.helpBullet.firstLine': '首行不要缩进，缩进不能跳级',
    'editor.textDraft.helpBullet.emptyLine': '空行会被忽略',
    'editor.textDraft.helpExample': '示例：',
    'editor.textDraft.helpExampleCode': '主题\n  子主题\n    子子主题\n  另一个子主题',
    'editor.outline.actions.export': '从画布生成',
    'editor.outline.actions.export.empty': '画布暂无可导出内容',
    'editor.outline.actions.exported': '已从画布生成文本',
    'editor.outline.actions.apply': '应用到画布',
    'editor.outline.actions.apply.empty': '请先输入大纲内容',
    'editor.outline.actions.apply.error': '大纲存在错误，无法应用',
    'editor.outline.actions.apply.success': '已应用到画布',
    'editor.outline.exportMode.label': '导出模式',
    'editor.outline.exportMode.collapsed': '考虑折叠',
    'editor.outline.exportMode.full': '完整内容',
    'editor.largeMap.notice': '已启用大图性能模式，仅渲染视口附近元素。',
    'editor.largeMap.recenter': '重新定位',
    'editor.outline.status.empty': '等待输入大纲',
    'editor.outline.status.ok': '解析通过',
    'editor.outline.status.error': '发现 {{count}} 处问题',
    'editor.outline.errors.line': '第 {{line}} 行',
    'editor.outline.errors.indentMultiple': '缩进需为 1 个 Tab 或 2 个空格的倍数',
    'editor.outline.errors.firstIndent': '首行缩进必须为 0',
    'editor.outline.errors.indentGap': '缩进断层：期望 {{expected}}，实际 {{actual}}',
    'editor.outline.errors.emptyLabel': '\u8BE5\u884C\u7F3A\u5C11\u53EF\u5BFC\u5165\u7684\u8282\u70B9\u6587\u672C',

    'msg.createdNewCanvas': '已创建新画布',
    'msg.cannotDeleteRoot': '不能删除根节点',
    'msg.deleteNode.confirm': '再次点击删除节点以确认',
    'msg.nodeDeleted': '节点已删除',
    'msg.copiedNode': '已复制节点',
    'msg.cannotCutRoot': '不能剪切根节点',
    'msg.cutNode': '已剪切节点',
    'msg.switchedLayout.horizontal': '已切换到水平逻辑图',
    'msg.switchedLayout.vertical': '已切换到垂直逻辑图',
    'msg.switchedLayout.radial': '已切换到辐射图',
    'msg.switchedLayout.fishbone': '已切换到鱼骨图',
    'msg.switchedLayout.orgchart': '已切换到组织结构图',
    'msg.export.failed': '导出失败，请重试',
    'msg.export.inProgress': 'Export is already running. Please wait.',
    'msg.export.loadFailed': '导出功能加载失败，请刷新页面后重试',
    'msg.export.json.success': 'JSON导出成功',
    'msg.largeMap.recentered': '已自动重新定位到可见节点，避免画布空白。',
    'msg.export.xmind.dev': 'XMind导出功能正在开发中',
    'msg.save.success': '思维导图已保存',
    'msg.save.inProgress': '\u6B63\u5728\u4FDD\u5B58\uFF0C\u8BF7\u7A0D\u5019...',
    'msg.save.failed': '\u4FDD\u5B58\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5',
    'msg.save.failedQuota': '\u4FDD\u5B58\u5931\u8D25\uFF1A\u6D4F\u89C8\u5668\u5B58\u50A8\u7A7A\u95F4\u4E0D\u8DB3\uFF0C\u8BF7\u6E05\u7406\u7A7A\u95F4\u6216\u5BFC\u51FA\u5907\u4EFD\u540E\u91CD\u8BD5',
    'msg.save.failedStorageUnavailable': '\u4FDD\u5B58\u5931\u8D25\uFF1A\u6D4F\u89C8\u5668\u672C\u5730\u5B58\u50A8\u4E0D\u53EF\u7528\uFF0C\u8BF7\u68C0\u67E5\u9690\u79C1\u8BBE\u7F6E\u540E\u91CD\u8BD5',
    'msg.project.load.success': '项目文件加载成功',
    'msg.project.parse.failed': '解析项目文件失败，文件可能已损坏',
    'msg.project.read.failed': '读取项目文件失败',
    'msg.project.import.failed': '导入项目文件失败，请重试',
    'msg.project.import.loading': '\u6B63\u5728\u5BFC\u5165\u9879\u76EE\u6587\u4EF6...',
    'msg.project.import.inProgress': '\u9879\u76EE\u5BFC\u5165\u8FDB\u884C\u4E2D\uFF0C\u8BF7\u7A0D\u5019...',
    'msg.project.import.unsupportedType': '\u6587\u4EF6\u683C\u5F0F\u4E0D\u652F\u6301\uFF0C\u8BF7\u9009\u62E9 {{extensions}} \u6587\u4EF6',
    'msg.project.import.empty': '\u9879\u76EE\u6587\u4EF6\u4E3A\u7A7A\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u6709\u6548\u6587\u4EF6',
    'msg.project.import.tooLarge': '\u9879\u76EE\u6587\u4EF6\u8FC7\u5927\uFF0C\u8BF7\u9009\u62E9\u4E0D\u8D85\u8FC7 {{maxSizeMB}} MB \u7684\u6587\u4EF6',
    'msg.import.success': '导入成功',
    'msg.autoSave.success': '已自动保存到浏览器缓存',
    'msg.autoSave.failed': '\u81EA\u52A8\u4FDD\u5B58\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u6D4F\u89C8\u5668\u5B58\u50A8\u7A7A\u95F4',
    'msg.import.invalidFormat': '导入数据格式不正确',
    'msg.import.failed': '导入失败，请检查数据格式',
    'msg.import.xmind.dev': 'XMind导入功能正在开发中',
    'msg.import.sanitize.reason.missingEndpoint': '\u7f3a\u5c11\u6765\u6e90\u6216\u76ee\u6807',
    'msg.import.sanitize.reason.missingNodeReference': '\u5f15\u7528\u4e86\u4e0d\u5b58\u5728\u7684\u8282\u70b9',
    'msg.import.sanitize.reason.selfLoop': '\u5b58\u5728\u81ea\u73af\u8fde\u63a5',
    'msg.import.sanitize.reason.duplicateConnection': '\u91cd\u590d\u8fde\u63a5',
    'msg.import.sanitize.reason.separator': '\u3001',
    'msg.xmind.import.loading': '\u6b63\u5728\u5bfc\u5165 XMind \u6587\u4ef6...',
    'msg.xmind.import.inProgress': 'XMind \u5bfc\u5165\u8fdb\u884c\u4e2d\uff0c\u8bf7\u7a0d\u5019...',
    'msg.xmind.import.validation.missingFile': '\u8bf7\u9009\u62e9\u8981\u5bfc\u5165\u7684 .xmind \u6587\u4ef6',
    'msg.xmind.import.validation.unsupportedType': '\u6587\u4ef6\u683c\u5f0f\u4e0d\u652f\u6301\uff0c\u8bf7\u9009\u62e9 {{extensions}}',
    'msg.xmind.import.validation.empty': '\u6240\u9009 XMind \u6587\u4ef6\u4e3a\u7a7a',
    'msg.xmind.import.validation.tooLarge': 'XMind \u6587\u4ef6\u8fc7\u5927\uff0c\u8bf7\u4f7f\u7528\u4e0d\u8d85\u8fc7 {{maxSizeMB}} MB \u7684\u6587\u4ef6',
    'msg.xmind.import.validation.failed': 'XMind \u5bfc\u5165\u6570\u636e\u6821\u9a8c\u5931\u8d25\uff1a{{reason}}',
    'msg.xmind.import.validation.structureFallback': '\u8bf7\u68c0\u67e5\u6587\u4ef6\u7ed3\u6784',
    'msg.xmind.import.warning.removedEdges': '\u5df2\u5728 XMind \u5bfc\u5165\u65f6\u79fb\u9664 {{count}} \u6761\u65e0\u6548\u8fde\u63a5',
    'msg.xmind.import.warning.removedEdgesWithReason': '\u5df2\u5728 XMind \u5bfc\u5165\u65f6\u79fb\u9664 {{count}} \u6761\u65e0\u6548\u8fde\u63a5\uff08{{reasons}}\uff09',
    'msg.xmind.import.warning.idFixes': '\u5df2\u5728 XMind \u5bfc\u5165\u65f6\u81ea\u52a8\u4fee\u590d {{count}} \u4e2a\u8282\u70b9\u6216\u8fde\u63a5 ID \u95ee\u9898',
    'msg.xmind.import.success.single': 'XMind \u5bfc\u5165\u6210\u529f\uff081 \u4e2a\u5de5\u4f5c\u8868\uff09\u3002',
    'msg.xmind.import.success.multiple': 'XMind \u5bfc\u5165\u6210\u529f\uff08{{count}} \u4e2a\u5de5\u4f5c\u8868\uff09\u3002',
    'msg.xmind.import.error.emptyInput': 'XMind \u5bfc\u5165\u5931\u8d25\uff1a\u672a\u627e\u5230\u6587\u4ef6\u5185\u5bb9\u3002',
    'msg.xmind.import.error.unsupportedInput': 'XMind \u5bfc\u5165\u5931\u8d25\uff1a\u4e0d\u652f\u6301\u7684\u6587\u4ef6\u5bf9\u8c61\u3002',
    'msg.xmind.import.error.invalidZip': 'XMind \u5bfc\u5165\u5931\u8d25\uff1a\u6587\u4ef6\u4e0d\u662f\u6709\u6548\u7684 .xmind \u538b\u7f29\u5305\u3002',
    'msg.xmind.import.error.contentNotFound': 'XMind \u5bfc\u5165\u5931\u8d25\uff1a\u538b\u7f29\u5305\u4e2d\u672a\u627e\u5230 content.json\u3002',
    'msg.xmind.import.error.invalidContentJson': 'XMind \u5bfc\u5165\u5931\u8d25\uff1a\u65e0\u6cd5\u89e3\u6790 {{entryName}}\u3002',
    'msg.xmind.import.error.legacyXml': '\u6b64 XMind \u6587\u4ef6\u4e3a\u65e7\u7248 XML \u683c\u5f0f\uff0c\u8bf7\u5148\u7528\u65b0\u7248 XMind \u53e6\u5b58\u4e3a .xmind\u3002',
    'msg.xmind.import.error.emptyWorkbook': 'XMind \u5bfc\u5165\u5931\u8d25\uff1a\u672a\u627e\u5230\u53ef\u5bfc\u5165\u7684\u5de5\u4f5c\u8868\u4e3b\u9898\u3002',
    'msg.xmind.import.error.emptyTopicGraph': 'XMind \u5bfc\u5165\u5931\u8d25\uff1a\u5de5\u4f5c\u8868\u4e2d\u672a\u627e\u5230\u4e3b\u9898\u8282\u70b9\u3002',
    'msg.xmind.import.error.generic': 'XMind \u5bfc\u5165\u5931\u8d25\uff0c\u8bf7\u68c0\u67e5\u6587\u4ef6\u540e\u91cd\u8bd5\u3002',
    'msg.upload.supported': '只支持 .json 或 .mmapx 格式的文件',
    'msg.unsaved.leave': '您有未保存的更改，确定要离开吗？',
    'msg.unsaved.newCanvas': '您有未保存的更改，新建画布将丢失当前所有更改。是否继续？',
    'msg.selectNodeFirst': '请先选择一个节点',
    'msg.focus.rootDisabled': '根节点无法进入孤立模式',
    'msg.image.invalid': '请先选择有效的图片文件',
    'msg.image.readFailed': '读取图片失败，请重试',
    'msg.image.insertedIntoNode': '图片已插入到当前节点',
    'msg.image.insertedNode': '图片节点已插入',
    'msg.image.relinked': '图片引用已更新',
    'msg.image.tooLarge': '\u5df2\u8df3\u8fc7 {{count}} \u5f20\u56fe\u7247\uff1a\u5355\u5f20\u6587\u4ef6\u4e0d\u80fd\u8d85\u8fc7 {{maxSizeMB}} MB',
    'msg.image.batchTooLarge': '\u5df2\u8df3\u8fc7 {{count}} \u5f20\u56fe\u7247\uff1a\u672c\u6b21\u5bfc\u5165\u603b\u5927\u5c0f\u4e0a\u9650\u4e3a {{maxBatchMB}} MB',
    'msg.image.recover.full': '已自动恢复 {{restored}} 张图片',
    'msg.image.recover.partial': '已自动恢复 {{restored}} 张图片，仍有 {{missing}} 张缺失',
    'msg.image.recover.noHandle': '导入图片未包含可恢复引用，请使用“重新定位”手动关联',
    'msg.clipboardEmpty': '剪贴板为空',
    'msg.selectTargetNodeFirst': '请先选择一个目标节点',
    'msg.editorNotReady': '思维导图编辑器未准备好，请稍后再试',
    'msg.export.unsupportedType': '不支持的导出格式: {{type}}',
    'msg.project.export.failed': '导出项目文件失败，请重试',

    'export.success.png': 'PNG导出成功',
    'export.fail.png': '导出PNG失败: {{msg}}',
    'export.success.jpg': 'JPG导出成功',
    'export.fail.jpg': '导出JPG失败: {{msg}}',
    'export.success.svg': 'SVG导出成功',
    'export.fail.svg': '导出SVG失败: {{msg}}',
    'export.success.pdf.vector': '矢量PDF导出成功',
    'export.fail.pdf.vector': 'PDF导出失败: {{msg}}',
    'export.success.pdf': 'PDF导出成功',
    'export.fail.pdf': '导出PDF失败: {{msg}}',
    'export.error.reactflow.uninit': 'ReactFlow实例未初始化，无法导出',
    'export.error.noNodes': '没有可导出的节点',
    'export.error.containerMissing': 'ReactFlow容器不存在',
    'export.error.unsupportedType': '不支持的导出格式: {{type}}',
    'export.default.filename': '思维导图',

    'nodepanel.palette.title': '色卡预设',
    'nodepanel.palette.help': '点击选择色卡，拖拽下方节点到画布',
    'nodepanel.tab.basic': '基本节点',
    'nodepanel.tab.shapes': '基础形状',
    'nodepanel.tab.effects': '特殊效果',
    'node.type.topic': '主题',
    'node.type.subtopic': '子主题',
    'node.type.note': '备注',
    'node.type.callout': '标注',
    'node.type.summary': '总结',

    'style.panel.title': '节点样式',
    'style.tab.basic': '基本样式',
    'style.tab.border': '边框样式',
    'style.tab.text': '文本格式',
    'style.tab.handle': '连接点样式',
    'style.tab.edge': '连接线样式',
    'style.tab.layout': '局部布局',
    'style.field.nodeText': '节点文本',
    'style.preset.title': '颜色预设',
    'style.field.backgroundColor': '背景颜色',
    'style.fill.on': '有填充',
    'style.fill.off': '无填充',
    'style.field.textColor': '文本颜色',
    'style.field.backgroundEffects': '背景效果',
    'style.field.borderColor': '边框颜色',
    'style.field.borderWidth': '边框宽度',
    'style.field.borderRadius': '边框圆角',
    'style.field.borderStyle': '边框样式',
    'style.border.toggle': '边框开关',
    'style.border.on': '有边框',
    'style.border.off': '无边框',
    'style.borderStyle.option.solid': '实线',
    'style.borderStyle.option.dashed': '虚线',
    'style.borderStyle.option.dotted': '点线',
    'style.borderStyle.option.double': '双线',
    'style.borderStyle.option.groove': '凹槽',
    'style.borderStyle.option.ridge': '凸起',
    'style.borderStyle.option.inset': '内嵌',
    'style.borderStyle.option.outset': '外凸',
    'style.text.fontFamily': '字体',
    'style.text.fontSize': '字号',
    'style.text.align': '文本对齐',
    'style.text.align.left': '左对齐',
    'style.text.align.center': '居中',
    'style.text.align.right': '右对齐',
    'style.text.style': '文本样式',
    'style.text.lineHeight': '行高',
    'style.text.letterSpacing': '字间距',
    'style.handle.color': '连接点颜色',
    'style.handle.size': '连接点大小',
    'style.edge.color': '连接线颜色',
    'style.edge.width': '连接线宽度',
    'style.effects.defaultStyle': '默认样式',
    'style.effects.shadow': '阴影',
    'style.effects.gradient': '渐变',
    'stylepanel.selectNodePrompt': '请选择一个节点以编辑样式',

    'editor.mode.free.label': '自由布局',
    'editor.mode.auto.label': '自动布局',
    'editor.mode.free.short': '自由',
    'editor.mode.auto.short': '自动',

    'preset.topic': '主题',
    'preset.subtopic': '子主题',
    'preset.note': '备注',
    'preset.emphasis': '强调',
    'preset.keypoint': '重点',
    'preset.tip': '提示',
    'preset.warning': '警告',
    'preset.info': '信息',
    'preset.success': '成功',
    'preset.danger': '危险',
    'preset.light': '浅色',
    'preset.dark': '深色',

    'msg.edge.sameNode': '不能连接到同一节点',
    'msg.cycle.blocked': '检测到循环关系，自动布局下已阻止连接。',
    'msg.cycle.allowed': '检测到循环关系，自由布局下已保留连接。',
    'msg.cycle.autoLayoutSkip': '检测到循环关系，自动布局已暂停。',
    'modal.multipleParents.title': '检测到多父级',
    'modal.multipleParents.content': '该节点已存在父节点，是否将新连接设为主父级？',
    'modal.multipleParents.primary': '设为主父级',
    'modal.multipleParents.secondary': '保留为次父级',
    'relationship.panel.title': '关系提醒',
    'relationship.multiParents': '多父级',
    'relationship.multiParents.hint': '自动布局仅使用主父级进行排列。',
    'relationship.cycles': '循环关系',
    'relationship.cycles.hint': '请先处理循环关系再应用自动布局。',
    'node.multipleParents.badge': '多父级：{{count}}',
    'node.branchStructure.badgeTooltip': '\u5206\u652f\u7ed3\u6784\uff1a{{structure}}\uff08{{source}}\uff09',
    'node.branchStructure.source.override': '\u5c40\u90e8\u8986\u76d6',
    'node.branchStructure.source.inherit': '\u7ee7\u627f',
    'node.branchStructure.source.global': '\u5168\u56fe\u9ed8\u8ba4',
    'node.image.missing': '图片缺失：{{name}}',
    'node.image.relocate': '重新定位',
    'editor.editNode.title': '编辑节点',
    'editor.editNode.save': '保存',
    'editor.editNode.cancel': '取消',
  }

export default zhCNDictionary
